import { useParams } from 'react-router'
import React, { useState } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import EditLeadTypeComp from '../../components/version-4/MasterForms/EditForms/EditLeadTypeComp'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { ROUTES } from '../../shared/constants'
import Loader from '../../components/Loader'
import LeadType from '../Masters/LeadTypeForm'

function EditLeadType() {
  // const [formPopup, setFormPopup] = useState(false)
  // const handlePosition = () => {
  //     setFormPopup(false);
  // }
  //  const handlePositionOpen = () => {
  //     setFormPopup(true);
  // }

  const params = useParams()

  const { leadType, getLeadType } = useLeadType()
  // const [leadTypedata, setLeadTypedata] = useState(leadType)
  const { updateLeadType } = useLeadType()
  React.useEffect(()=>{
    // setLeadTypedata(leadType)
  },[leadType])

  // const handleLead = () => {
  //   updateLeadType({ name: leadTypedata.name, leadTypeId: params.leadTypeId })
  // }

  React.useEffect(() => {
    getLeadType({ leadTypeId: params.leadTypeId })
  }, [params.leadTypeId])

  return (
    // <Layout heading="Lead Types" heading2="Edit" url1={ROUTES.LEAD_TYPE} none form>
    //   {/* { formPopup && <LeadTypePopup open={formPopup} handleClose={handlePosition} />
    //         } */}
    //   <HeaderTabLayout
    //     heading="Lead type"
    //     content={<EditLeadTypeComp state={leadTypedata} setState={setLeadTypedata} />}
    //     redirect={ROUTES.LEAD_TYPE}
    //     addContent={handleLead}
    //   />
    // </Layout>

    <>{leadType ? <LeadType leadType={leadType} /> : <Loader />}</>
  )
}

export default EditLeadType
